export default "__VITE_ASSET__Vs6adh3A__"